import { __ } from "@wordpress/i18n";
import { useEffect, useState } from "@wordpress/element";

import { PanelBody, PanelRow, Button } from "@wordpress/components";
import BColor from "../../../../../components/BColor/BColor";
import BMediaUpload from "../../../../../components/BMediaUpload/BMediaUpload";
import BUnitControl from "../../../../../components/BUnitControl/BUnitControl";
import BDevice from "../../../../../../../Components/BDevice/BDevice";
import { BControlPro } from "../../../../../../../wp-utils/v1/components/";

const Style = ({ attributes, setAttributes }) => {
  const { styles, woo } = attributes;
  const { width, height, bgColor, bgImage, progressBar, progressBarColor } = styles;

  const [device, setDevice] = useState("desktop");

  useEffect(() => {
    if (typeof height === "string") {
      setAttributes({
        styles: {
          ...styles,
          height: {
            desktop: height,
            tablet: height,
            mobile: height,
          },
        },
      });
    }
    if (typeof width === "string") {
      setAttributes({
        styles: {
          ...styles,
          width: {
            desktop: width,
            tablet: width,
            mobile: width,
          },
        },
      });
    }
  }, []);

  return (
    <PanelBody title={__("Style", "b3d-viewer-lite")}>
      {!woo && (
        <PanelRow className="deviceForUnit">
          <label>{__("Width", "b3d-viewer-lite")}</label>
          <BUnitControl
            value={width[device]}
            onChange={(width) => setAttributes({ styles: { ...styles, width: { ...styles.width, [device]: width } } })}
            units={[
              { value: "px", label: "px", default: 500 },
              { value: "%", label: "%", default: 100 },
            ]}
          />
          <BDevice device={device} onChange={(device) => setDevice(device)} />
        </PanelRow>
      )}
      <PanelRow className="deviceForUnit">
        <label>{__("Height", "b3d-viewer-lite")}</label>
        <BUnitControl
          value={height[device]}
          onChange={(height) => setAttributes({ styles: { ...styles, height: { ...styles.height, [device]: height } } })}
          units={[
            { value: "px", label: "px", default: 500 },
            { value: "%", label: "%", default: 100 },
            { value: "vh", label: "vh", default: 100 },
          ]}
        />
        <BDevice device={device} onChange={(device) => setDevice(device)} />
      </PanelRow>
      <PanelRow>
        <label>{__("Background Color", "b3d-viewer-lite")}</label>
        <BColor value={bgColor || "#ffffff"} defaultColor="#ffffff" onChange={(bgColor) => setAttributes({ styles: { ...styles, bgColor } })} />
      </PanelRow>
      <PanelRow>
        <label>
          <strong>{__("Note: Color will be ignore if background image used", "b3d-viewer-lite")}</strong>
        </label>
      </PanelRow>
      <br />
      <PanelRow>
        <BControlPro Component={BMediaUpload} media={true} label={__("Background Image", "b3d-viewer-lite")} placeholder={__("Background Image", "b3d-viewer-lite")} value={bgImage} onSelect={(bgImage) => setAttributes({ styles: { ...styles, bgImage } })} />
      </PanelRow>
      {progressBar && (
        <PanelRow>
          <label>{__("ProgressBar Color", "b3d-viewer-lite")}</label>
          <BColor value={progressBarColor || "#666"} defaultColor="#666" onChange={(progressBarColor) => setAttributes({ styles: { ...styles, progressBarColor } })} />
        </PanelRow>
      )}
    </PanelBody>
  );
};

export default Style;
